export const TWO_FA_MANDATORY_DATE = new Date('2026-07-07');
